import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";

import { FiX } from "react-icons/fi";
import {
  getLocationChoice,
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const LocationChoiceModal = ({ show, onHide, selectedChoice }) => {
  const [localChoice, setLocalChoice] = useState([] || "");
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const handleChoiceToggle = (choice) => {
    const isAlreadySelected = localChoice.some((c) => c.id === choice.id);

    if (isAlreadySelected) {
      setLocalChoice(localChoice.filter((c) => c.id !== choice.id));
    } else {
      if (localChoice.length < 2) {
        setLocalChoice([...localChoice, choice]);
      }
    }
  };

  useEffect(() => {
    if (show && store?.locationChoiceItems?.data?.location_choices) {
      // Parse selectedChoice if it's a string
      let parsedChoice = selectedChoice;
      if (typeof selectedChoice === "string") {
        try {
          parsedChoice = JSON.parse(selectedChoice);
        } catch (e) {
          parsedChoice = [];
        }
      }

      // Map selectedChoice to match location_choices structure by matching on id or name/title
      const locationChoices =
        store?.locationChoiceItems?.data?.location_choices || [];
      const mappedChoices = Array.isArray(parsedChoice)
        ? parsedChoice
            .map((selected) => {
              // Find matching choice by id (handle both number and string comparison) or by name/title
              return locationChoices.find(
                (choice) =>
                  String(choice.id) === String(selected.id) ||
                  String(choice.id) ===
                    String(selected.location_choice_for_id) ||
                  choice.name === selected.location_title ||
                  choice.name === selected.name,
              );
            })
            .filter(Boolean) // Remove any undefined matches
        : [];

      // Remove duplicates and limit to 2 choices
      const uniqueChoices = Array.from(
        new Map(mappedChoices.map((item) => [item.id, item])).values(),
      ).slice(0, 2);

      setLocalChoice(uniqueChoices);
    }
  }, [
    show,
    selectedChoice,
    store?.locationChoiceItems?.data?.location_choices,
  ]);

  useEffect(() => {
    // Fetch location choices on mount
    dispatch(getLocationChoice());
  }, []);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  const onSubmit = () => {
    if (!store?.profileItem?.data?.full_name) return;

    // Step 1: Extract unique IDs from localChoice
    const uniqueChoices = Array.from(
      new Map(localChoice.map((item) => [item.id, item])).values(),
    );

    // Step 2: Prepare form data
    const formData = new FormData();
    formData.append("name", store?.profileItem?.data?.full_name);

    // Step 3: Send locations_for array with current selections
    // Backend compares incoming vs existing and removes the difference
    uniqueChoices.forEach((choice) => {
      formData.append("locations_for[]", String(choice.id));
    });

    // Step 4: Dispatch update and clear state after success
    dispatch(updateProfile(formData));
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
      dispatch(getLocationChoice());
    }
  }, [dispatch, store?.actionFlag]);

  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_IMPORTANT_FACTOR_FOR_CHOOSING_LOCATION", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_IMPORTANT_FACTOR_FOR_CHOOSING_LOCATION" }));
    };
  }, [show, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">
          What’s most important to you when choosing a location?
        </h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {store?.locationChoiceItems?.data?.location_choices?.map(
              (choice) => (
                <div
                  key={choice.id}
                  className={`checkbox-option col-lg-6 ${
                    localChoice.some((c) => c.id === choice.id)
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => handleChoiceToggle(choice)}
                >
                  <div className="contentwrap">
                    <input
                      type="checkbox"
                      name="locationChoice"
                      id={`choice-${choice.id}`}
                      value={choice.name}
                      checked={localChoice?.some((c) => c.id === choice.id)}
                      readOnly
                      disabled={localChoice?.length >= 2 ? true : false}
                    />
                    <label
                      htmlFor={`choice-${choice.name}`}
                      className="checkbox-label"
                    >
                      {choice.name}
                    </label>
                  </div>
                </div>
              ),
            )}
          </div>
        </div>
        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={store?.isLoading || !localChoice || localChoice.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LocationChoiceModal;
